import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-logo">
              <span>E-Minister Portal</span>
            </div>
            <p className="footer-description">
              Khyber Pakhtunkhwa's digital platform for citizen engagement and
              transparent governance.
            </p>
          </div>

          <div className="footer-links-grid">
            <div className="footer-links-column">
              <h4>Quick Links</h4>
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/submit-complaint">File Complaint</Link>
                </li>
                <li>
                  <Link to="/submit-suggestion">Give Suggestion</Link>
                </li>
                <li>
                  <Link to="/complaint-status">Check Status</Link>
                </li>
              </ul>
            </div>

            <div className="footer-links-column">
              <h4>Resources</h4>
              <ul>
                <li>
                  <Link to="/guidelines">Guidelines</Link>
                </li>
                <li>
                  <Link to="/faq">FAQ</Link>
                </li>
                <li>
                  <Link to="/resources">Government Resources</Link>
                </li>
                <li>
                  <Link to="/how-to-file-complaint">How to File</Link>
                </li>
              </ul>
            </div>

            <div className="footer-links-column">
              <h4>Contact</h4>
              <ul>
                <li>
                  <span className="contact-icon">📧</span>{" "}
                  Sabahat_Ghaznavi@yahoo.com
                </li>
                <li>
                  <span className="contact-icon">📞</span> 03129425477
                </li>
                <li>
                  <span className="contact-icon">📍</span> Peshawar, KP,
                  Pakistan
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>
              © 2026 <strong>E-Minister Portal</strong>. All rights reserved.
            </p>
            <div className="footer-bottom-links">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <span className="divider">|</span>
              <Link to="/terms-of-service">Terms of Service</Link>
              <span className="divider">|</span>
              <Link to="/accessibility">Accessibility</Link>
              <Link to="/meet-our-team">Meet Developers of This Site</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
